export abstract class BdExportAsFileConverter {
  protected constructor(
    protected _locale: string,
    public filename: string
  ) {}

  protected static _instanceOfNumberFormatOptions(object: any): boolean {
    if (!object) {
      return false;
    }

    return (
      'localeMatcher' in object ||
      'style' in object ||
      'currency' in object ||
      'currencyDisplay' in object ||
      'currencySign' in object ||
      'useGrouping' in object ||
      'minimumIntegerDigits' in object ||
      'minimumFractionDigits' in object ||
      'maximumFractionDigits' in object ||
      'minimumSignificantDigits' in object ||
      'maximumSignificantDigits' in object
    );
  }

  protected static _instanceOfDateTimeFormatOptions(object: any): boolean {
    if (!object) {
      return false;
    }

    return (
      'localeMatcher' in object ||
      'weekday' in object ||
      'era' in object ||
      'year' in object ||
      'month' in object ||
      'day' in object ||
      'hour' in object ||
      'minute' in object ||
      'second' in object ||
      'timeZoneName' in object ||
      'formatMatcher' in object ||
      'hour12' in object ||
      'timeZone' in object
    );
  }

  public abstract process(): Promise<{ result?: Blob; errors?: string[] }>;
}
